import styled, { css } from 'styled-components';
import { space } from 'styled-system';
export var Row = styled.div.withConfig({
  displayName: "PrefixAndSuffixstyles__Row",
  componentId: "keen-widget-settings__sc-1jnkkd3-0"
})(["&&&{display:flex;align-items:center;justify-content:space-between;column-gap:10px;", ";", ";}"], space, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && css(["opacity:0.5;pointer-events:none;"]);
});
export var Container = styled.div.withConfig({
  displayName: "PrefixAndSuffixstyles__Container",
  componentId: "keen-widget-settings__sc-1jnkkd3-1"
})(["&&&{display:flex;flex-direction:column;row-gap:10px;}"]);
export var ControlContainer = styled.div.withConfig({
  displayName: "PrefixAndSuffixstyles__ControlContainer",
  componentId: "keen-widget-settings__sc-1jnkkd3-2"
})(["&&&{width:100%;max-width:310px;}"]);